export default __webpack_public_path__ + "static/media/linkedin.9a1a7f81.png";